import styled from '@emotion/styled'
import { Button } from 'antd'

export const DeleteButton = styled(Button)`
  color: #a40000;
  background: transparent;
  border: 1px solid #a40000;

  &:disabled,
  &:hover,
  &:focus,
  &:active {
    color: #a40000;
    background: transparent;
    border: 1px solid #a40000;
  }

  &:disabled {
    opacity: 0.4;

    &:hover,
    &:focus,
    &:active {
      color: #a40000;
      background: transparent;
      border: 1px solid #a40000;
    }
  }
`
